<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="lg"
    v-model="open"
    :title="title"
    :busy="loading"
    :hide-footer="true"
  >
    <b-row>
      <b-col cols="12" class="mt-2">
        <h5 class="mt-4"><strong>Produto: </strong>{{ product.product }}</h5>
        <div v-if="!isEditPrice" class="d-flex">
          <h5><strong>Preço: </strong>
            {{ formatNumber(product.priceSalesFormat1) }}
          </h5>
          <b-button 
            class="ml-2" 
            size="sm" 
            variant="outline-primary"
            @click="editPrice()"
          >
            <i class="fas fa-edit fs-14"></i>
            Alterar preço
          </b-button>
        </div>

        <div v-else class="mt-4">
          <label>Valor de Venda</label>
          <div class="d-flex">
            <b-input-group
              prepend="R$"
              style="width: 48%;"
            >
              <b-form-input
                v-model="fields.price"
                v-mask="['.##','#.##', '##.##','###.##','####.##', '#####.##']"
                placeholder="Ex: 99.90"
                type="number"
              ></b-form-input>
            </b-input-group>
            <b-button 
              @click="editPrice()"
              class="ml-4" 
              size="sm" 
              variant="danger"
            >
              <i class="fas fa-save fs-14"></i>
              Cancelar
            </b-button>
          </div>
        </div>
      </b-col>
      
      <b-col cols="6" v-if="!loading" class="mt-4">
        <label>Custo do Produto</label>
        <b-input-group 
          prepend="R$" 
        >
          <b-form-input 
            v-model="fields.costPrice"
            v-mask="['.##','#.##', '##.##','###.##','####.##', '#####.##']"
            placeholder="Ex: 99.90"
            type="number"
          ></b-form-input>
        </b-input-group>
        <p v-if="errorPrice" class="fs-16 text-danger">{{ errorPrice }}</p>
      </b-col>

      <b-col cols="6" v-if="!loading" class="mt-4">
        <label>Taxa Imposto</label>
        <b-input-group append="%" class="w-75 mb-2 mr-sm-2 mb-sm-0">
          <b-form-input 
            v-model="fields.tax"
            v-mask="['##']"
            placeholder="Ex: 10"
            type="number"
          ></b-form-input>
        </b-input-group>
      </b-col>

      <b-col cols="12" v-if="!loading" class="mt-4 d-flex">
        <p class="fs-18">Lucro sem taxa de pagamento: </p>
        <div class="d-flex">
          <h5 class="ml-2"><b-badge variant="success">{{ formatNumber(calcProfit('profit')) }}</b-badge></h5>
          <h5 class="ml-1"><b-badge variant="warning">
            {{ calcProfit('profitPercentage') }}%
          </b-badge></h5>
        </div>
      </b-col>

      <b-col v-if="!loading" class="mt-3">
        <p>Lucro no Pix</p>
        <div class="d-flex">
          <h5><b-badge variant="primary">{{ formatNumber(calcProfit('pix')) }}</b-badge></h5>
          <h5 class="ml-1"><b-badge variant="info">{{ calcProfit('pixPercentage') }}%</b-badge></h5>
        </div>
      </b-col>

      <b-col v-if="!loading" class="mt-3">
        <p>Lucro no Boleto</p>
        <div class="d-flex">
          <h5><b-badge variant="primary">{{ formatNumber(calcProfit('all')) }}</b-badge></h5>
          <h5 class="ml-1"><b-badge variant="info">{{ calcProfit('allPercentage') }}%</b-badge></h5>
        </div>
      </b-col>

      <b-col v-if="!loading" class="mt-3">
        <p>Lucro no Cartão</p>
        <div class="d-flex">
          <h5><b-badge variant="primary">{{ formatNumber(calcProfit('card')) }}</b-badge></h5>
          <h5 class="ml-1"><b-badge variant="info">
            {{ calcProfit('cardPercentage') }}%
          </b-badge></h5>
        </div>
      </b-col>
    </b-row>
    
    <b-row v-if="!loading" class="mt-4 d-flex justify-content-around">
      <b-col>
        <b-button
          class="mr-3 w-100"
          @click="closeModal()"
          variant="outline-danger"
        >
          Cancelar
        </b-button>
      </b-col>

      <b-col>
        <b-button
            class="mr-3 w-100"
            @click="save()"
            variant="success"
          >
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import makeToast from '@/mixins/makeToast';
import { calculateProfit } from '@/enums/TaxIugu'

export default {
  name: 'percentagePartnerModal',
  emits: ['save'],
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      open: false,
      errorPrice: "",
      title: '',
      isEditPrice: false,
      product:[],
      partnersProduct: [],
      fields: {
        tax: 0,
        costPrice: 0,
        price: 0
      }
    };
  },

  methods: {
    toggleOpen({ product = [], partners = [], title = '' }) {
      this.open = !this.open;
      this.cleanForm();
      this.product = product
      this.partnersProduct = partners;
      this.fields.tax = product.tax_rate;
      this.fields.costPrice = product.cost_price;
      this.title = !title ? "Vincular Produto" : title;
    },
    save() {
      if(!this.fields.costPrice || !this.fields.tax) {
        this.makeToast('Erro', 'O custo e o imposto não podem estar vazios ou zerados!', 'danger');
        return;
      }

      let price = this.product.priceSalesFormat1;
      if(this.isEditPrice && this.fields.price != this.product.priceSalesFormat1) {
        price = this.fields.price;
      }

      if(this.fields.costPrice > price) {
        this.errorPrice = "O custo não pode ser maior que o valor da venda";
        return
      }

      const data = {
        "id": this.partnersProduct ? this.partnersProduct.id : 0,
        "product_id" : this.product.productId,
        "selected_product_id" : this.product.id,
        "tax_rate" : this.fields.tax,
        "cost_price": this.fields.costPrice,
        "price_sales_format_1": price
      }

      this.$emit('save', data);
      this.closeModal();
    },
  
    closeModal(){
      this.open = !this.open;
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    calcProfit(type) {
      if (!this.fields.tax || !this.fields.costPrice) return 0;

      let price = this.product.priceSalesFormat1
      if(this.isEditPrice) price = this.fields.price;
      
      return calculateProfit(
        type, 
        price, 
        this.fields.costPrice, 
        this.fields.tax
      );
    }, 
    editPrice(){
      this.isEditPrice = !this.isEditPrice;
      this.fields.price = this.isEditPrice ? 
        this.product.priceSalesFormat1 : 0;
    },
    cleanForm() {
      this.isEditPrice = false;
      this.product =[];
      this.partnersProduct = [];
      this.fields.tax = 0;
      this.fields.costPrice = 0;
      this.fields.price = 0;
    },
  },
};
</script>
